import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validateStep5 } from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupFull,
    MultipleGroupLastLarge
} from '../../containers/DefaultStyles/FormDetails';

class VoteRegistrationStep5Form extends React.Component {
    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupLastLarge>
                    <Field
                        name="mailingAddress"
                        component={InputGroup}
                        type="text"
                        label="Mailing Street No & Street"
                        placeholder="Street No & Street"
                        autocomplete="off"
                    />
                    <Field
                        name="mailingUnit"
                        component={InputGroup}
                        type="text"
                        label="Mailing Unit"
                        placeholder="Unit"
                        autocomplete="off"
                    />
                </MultipleGroupLastLarge>
                <MultipleGroupFull>
                    <Field
                        name="mailingCity"
                        component={InputGroup}
                        type="text"
                        label="Mailing city"
                        placeholder="City"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name="mailingStateId"
                        component={DropDownSelect}
                        options={this.props.states}
                        defaultOption={'Choose'}
                        label="Mailing State"
                        type="text"
                    />
                    <Field
                        name="mailingPostalCode"
                        component={InputGroup}
                        type="text"
                        label="Mailing Postal code"
                        placeholder="Postal Code"
                        autocomplete="off"
                        maxLength={5}
                    />
                </MultipleGroupFull>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            disabled={this.props.invalid}
                        />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep5Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    states: PropTypes.array
};

export default compose(
    connect(state => ({
        initialValues: {
            mailingAddress: state.cachedFormData.address || '',
            mailingUnit: state.cachedFormData.unit || '',
            mailingCity: state.cachedFormData.city || '',
            mailingStateId: state.cachedFormData.stateId || '',
            mailingPostalCode: state.cachedFormData.postalCode || ''
        }
    })),
    reduxForm({
        form: 'voteRegistrationStep5Form',
        validate: validateStep5,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep5Form);



// WEBPACK FOOTER //
// ./src/components/VoteRegistration/VoteRegistrationStep5Form.jsx